//1.Import
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js"


import Layout from '../Layout';
//2.Initialization

const layout=new Layout();
//3.Events
window.addEventListener('DOMContentLoaded', function() {
    flatpickr("#schedule", {
        locale: Japanese,
        disableMobile: true,
        dateFormat: "Y/m/d",
        onChange: function(selectedDates, dateStr, instance) {
            // Hide the element when a date is selected
            document.querySelector('.contact-form__placeholder').style.display = 'none';
        }
    });

    flatpickr("#event-time", {
        locale: Japanese,
        disableMobile: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: 10,
        position: 'above center',
        onOpen: function(selectedDates, dateStr, instance) {
            setTimeout(function() {
                instance.input.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
        }
    });

    const contactForm = document.querySelector(".wpcf7");

    if (contactForm) {
        contactForm.addEventListener(
            "wpcf7mailsent",
            function (event) {
                location = thankyouUrl;
            },
            false
        );
    }
});

//4. Functions
document.addEventListener('DOMContentLoaded', function() {
    // Automation Script for "Date Not Yet Confirmed" Checkbox
    const checkbox = document.querySelector('#schedule-undecided input');
    const dateInput = document.getElementById('schedule');
    const timeInput = document.getElementById('event-time');

    if (checkbox && dateInput && timeInput) {
        function toggleInputs() {
            if (checkbox.checked) {
                dateInput.value = '';
                timeInput.value = '';
                dateInput.setAttribute('disabled', 'disabled');
                timeInput.setAttribute('disabled', 'disabled');
                dateInput.style.backgroundColor = '#e9ecef';
                timeInput.style.backgroundColor = '#e9ecef';
            } else {
                dateInput.removeAttribute('disabled');
                timeInput.removeAttribute('disabled');
                dateInput.style.backgroundColor = '';
                timeInput.style.backgroundColor = '';
            }
        }

        checkbox.addEventListener('change', toggleInputs);
        toggleInputs();
    }
});